/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ControlIntegrationType = {
    Collaboration: 'collaboration',
    Endpoint: 'endpoint',
    Identity: 'identity',
    NetworkVpn: 'network_vpn',
    Cloud: 'cloud',
    Saas: 'saas',
    AttackSimulation: 'attack_simulation',
    Deception: 'deception',
    Enrichment: 'enrichment',
    Email: 'email',
    Firewall: 'firewall',
    Dns: 'dns',
    Custom: 'custom',
    Free: 'free'
} as const;
export type ControlIntegrationType = typeof ControlIntegrationType[keyof typeof ControlIntegrationType];


export function ControlIntegrationTypeFromJSON(json: any): ControlIntegrationType {
    return ControlIntegrationTypeFromJSONTyped(json, false);
}

export function ControlIntegrationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlIntegrationType {
    return json as ControlIntegrationType;
}

export function ControlIntegrationTypeToJSON(value?: ControlIntegrationType | null): any {
    return value as any;
}

